import type { Site } from '@hotjar/site';
import { isAllowed } from '@hotjar/feature-flags';
import { isAllowedForAsk } from '@hotjar/feedback/domain/common/Feature/feature';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';

// Used for tracking purposes, like reference name for upsell modal
export const FEATURE_NAME = 'settings.integrations_zapier';

// Name of the minimal plan required to show the feature to the user
export const FEATURE_GROUP = 'business';

export function canUse(contextOfUse: ProductType | 'any', site: Site): boolean {
  switch (contextOfUse) {
    case ProductType.Feedback:
      return isAllowedForAsk(FEATURE_NAME, site);
    case ProductType.Analytics:
      return isAllowed(FEATURE_NAME, site);
    case 'any':
    default:
      return isAllowed(FEATURE_NAME, site) || isAllowedForAsk(FEATURE_NAME, site);
  }
}

export const CREATE_ZAP_URL = 'https://zapier.com/app/editor';
